import React from 'react';
import TransactionStatement from '../components/TransactionStatement/TransactionStatement';

const TransactionStatementPage = () => {
  return <TransactionStatement />;
};

export default TransactionStatementPage; 